export const isValidRelativeUrl = (url?: string) => {
  if (!url) {
    return false;
  }

  const isAllowedProtocol = (url: URL) => {
    const allowedProtocols = ['http:', 'https:'];
    return allowedProtocols.includes(url.protocol);
  };

  const hasForbiddenKeywords = (url: string): boolean => {
    const forbiddenKeywords = [
      '\\bjavascript:',
      '<script>',
      'eval\\(',
      'import\\(',
      'document\\.write',
      '\\bonerror=',
      '\\bonload=',
      '\\bdata:',
      '\\bfile:',
      '\\bblob:',
    ];
    const regex = new RegExp(forbiddenKeywords.join('|'), 'i');
    return regex.test(url);
  };

  if (hasForbiddenKeywords(url)) {
    return false;
  }

  try {
    const completeUrl = new URL(url);
    return (
      isAllowedProtocol(completeUrl) &&
      completeUrl.hostname === 'developer.semrush.com'
    );
  } catch {
    try {
      const newUrl = new URL(`${window.location.origin + url}`);
      return (
        isAllowedProtocol(newUrl) &&
        newUrl.pathname[0] === '/' &&
        newUrl.pathname[1] !== '/' &&
        !/\\([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}/.test(newUrl.pathname)
      );
    } catch {
      return false;
    }
  }
};

export const validateRedirectTo = (redirectTo?: string) => {
  if (redirectTo && isValidRelativeUrl(redirectTo)) {
    return redirectTo;
  }

  return null;
};
